import { Modal, Button } from "antd";

const ConfirmModal = ({
  open,
  onCancel,
  onConfirm,
  title = "Are you sure?",
  description = "",
  confirmText = "Confirm",
  cancelText = "Cancel",
  icon ="",
  loading = false,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={400}
    >
      <div className="d-flex flex-column align-items-center text-center px-2 py-3">

        {/* Icon circle */}
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: "#fff1f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 16,
          }}
        >
          {icon}
        </div>

        {/* Title */}
        <h6
          className="fw-500 mb-2"
          style={{ fontSize: 20, color: "#000000" }}
        >
          {title}
        </h6>

        {/* Description */}
        <p
          className="text-secondary mb-4"
          style={{ fontSize: 14, lineHeight: 1.6 }}
        >
          {description}
        </p>

        {/* Buttons */}
        <div className="d-flex gap-3 w-100">
          <Button
            block
            size="large"
            onClick={onCancel}
            style={{ borderRadius: 8 }}
          >
            {cancelText}
          </Button>
          <Button
            block
            size="large"
            onClick={onConfirm}
            disabled={loading}
            loading={loading}
            style={{
              borderRadius: 8,
              background: "#1a6b3c",
              borderColor: "#1a6b3c",
              color: "#fff",
            }}
          >
            {confirmText}
          </Button>
        </div>

      </div>
    </Modal>
  );
};

export default ConfirmModal;